var _style, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.1 40.5",
    style: {
      enableBackground: "new 0 0 48.1 40.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#029D8B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,40.5c-11.2,0-20.3-9.1-20.3-20.2S10.6,0,21.8,0c3.9,0,7.7,1.1,10.9,3.2c0.6,0.4,0.8,1.3,0.4,1.9 c-0.4,0.6-1.3,0.8-1.9,0.4c-2.8-1.8-6.1-2.8-9.4-2.8c-9.6,0-17.5,7.8-17.5,17.5c0,9.6,7.8,17.5,17.5,17.5c9.6,0,17.5-7.8,17.5-17.5 c0-0.6,0-1.1-0.1-1.7c-0.1-0.8,0.5-1.4,1.2-1.5c0.8-0.1,1.4,0.5,1.5,1.2c0.1,0.6,0.1,1.3,0.1,2C42.1,31.4,33,40.5,21.8,40.5z  M44.2,2.6L24.8,21.5l-7.4-7.1c-0.5-0.5-1.4-0.5-2,0c-0.5,0.5-0.5,1.4,0,1.9l8.3,8.1c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4 L46.1,4.6c0.5-0.5,0.5-1.4,0-1.9S44.7,2.1,44.2,2.6z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-icon.c85ee4d4.svg";
export { ForwardRef as ReactComponent };